import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { parseFiltersFromUrl } from 'site-modules/shared/utils/lease-deals/filter-url-utils';
import { LeaseDealsModel, LeaseDealsPaths } from 'client/data/models/lease-deals';

export const useRestoreFiltersFromHistory = setModelValue => {
  const { action } = useSelector(state => state.router);
  const query = useSelector(state => state.pageContext.location.query);

  useEffect(() => {
    if (action === 'POP') {
      setModelValue(LeaseDealsPaths.getSelectedFiltersPath(), LeaseDealsModel, {
        ...parseFiltersFromUrl(query),
        shouldOverride: true,
      });
    }
  }, [action, query, setModelValue]);
};
